
<template>
  <div>
    <van-nav-bar
      title="个人资料"
      fixed
      placeholder
      left-text="返回"
      left-arrow
      @click-left="goBack"
    />
    <div class="mt-2">
      <van-cell-group title="">
        <van-cell title="姓名" :value="user.name" />
        <van-cell title="学号" :value="user.id" />
        <van-cell title="学院班级" :value="user.deptName" />
      </van-cell-group>
      <br/>
      <van-cell-group title="">
        <van-cell title="电话" :value="user.tel" />
        <van-cell title="手机" :value="user.mobile" />
        <van-cell title="Email" :value="user.email" />
        <van-cell title="QQ" :value="user.qq" />
      </van-cell-group>
    </div>
  </div>
</template>

<script>
import { toRefs, reactive } from "vue";
import { useRouter } from "vue-router";
import Cookies from "js-cookie";
export default {
  name: "myProfile",
  components: {},
  setup() {
    const router = useRouter();
    const state = reactive({
      user: JSON.parse(Cookies.get("userObj"))
    });

    const goBack = () => router.go(-1);

    return {
      goBack,
      ...toRefs(state),
    };
  },
};
</script>

<style lang="less" >
@import "../common/style/base";
.selected {
  background-color: #49cfd4;
  color: white;
}
.van-cell__title {
  flex: 1 1 auto;
}
.van-cell__value {
  flex: 1 1 auto;
}
</style>
